export default __webpack_public_path__ + "static/media/563.c463d0e5.png";